import { z } from 'zod'

export const FileCloneDriveGroupModel = z.object({
  id: z.string(),
  fileName: z.string(),
  originalFileName: z.string(),
  size: z.number(),
  fileType: z.string(),
  folderId: z.string().nullable(),
  fileUrl: z.string(),
  uploadedBy: z.object({
    userId: z.string(),
    username: z.string(),
    avatarUrl: z.string()
  }),
  createdAt: z.string()
})

export type FileCloneDriveGroup = z.infer<typeof FileCloneDriveGroupModel>
